import React, { useEffect, useState } from "react";

import {
    Card
} from "primereact/card";

import {
    Dropdown
} from "primereact/dropdown";

import {
    Button
} from "primereact/button";

import {
    DataTable
} from "primereact/datatable";

import {
    Column
} from "primereact/column";

import {
    ProgressSpinner
} from "primereact/progressspinner";

import {
    Message
} from "primereact/message";

import "./SalarySlip.css";

const API_URL =
    process.env.REACT_APP_API_PATH || "http://localhost:8060";

const months = [
    { label: "January", value: 1 },
    { label: "February", value: 2 },
    { label: "March", value: 3 },
    { label: "April", value: 4 },
    { label: "May", value: 5 },
    { label: "June", value: 6 },
    { label: "July", value: 7 },
    { label: "August", value: 8 },
    { label: "September", value: 9 },
    { label: "October", value: 10 },
    { label: "November", value: 11 },
    { label: "December", value: 12 }
];

const years = [];

for (let year = 2020; year <= new Date().getFullYear() + 1; year++) {
    years.push({
        label: year.toString(),
        value: year
    });
}

function SalarySlip() {

    const currentDate = new Date();

    const [month, setMonth] = useState(
        currentDate.getMonth() + 1
    );

    const [year, setYear] = useState(
        currentDate.getFullYear()
    );

    const [empCode, setEmpCode] = useState("");

    const [salarySlips, setSalarySlips] = useState([]);

    const [selectedSlip, setSelectedSlip] = useState(null);

    const [loading, setLoading] = useState(false);

    const [error, setError] = useState("");

    const money = (value) => {

        return new Intl.NumberFormat("en-IN", {
            style: "currency",
            currency: "INR",
            minimumFractionDigits: 2
        }).format(value || 0);

    };

    const formatDate = (value) => {

        if (!value)
            return "";

        return new Date(value).toLocaleDateString(
            "en-IN",
            {
                day: "2-digit",
                month: "2-digit",
                year: "numeric"
            }
        );
    };

    const loadSalarySlip = async () => {

        try {

            setLoading(true);
            setError("");
            setSelectedSlip(null);

            let url =
                `${API_URL}salary/salary-slip` +
                `?month=${month}` +
                `&year=${year}`;

            if (empCode && empCode.trim() !== "") {

                url +=
                    `&empCode=${encodeURIComponent(
                        empCode.trim()
                    )}`;

            }

            const token =
                localStorage.getItem("accessToken");

            const response = await fetch(url, {
                method: "GET",

                headers: {
                    "Content-Type": "application/json",

                    ...(token
                        ? {
                            Authorization:
                                `Bearer ${token}`
                        }
                        : {})
                }
            });

            if (!response.ok) {

                const errorData =
                    await response.json()
                        .catch(() => null);

                throw new Error(
                    errorData?.message ||
                    "Unable to load salary slip."
                );
            }

            const data = await response.json();

            setSalarySlips(data);

            if (data.length > 0) {

                setSelectedSlip(data[0]);

            }

        }
        catch (err) {

            console.error(err);

            setSalarySlips([]);

            setError(
                err.message ||
                "Unable to load salary slip."
            );

        }
        finally {

            setLoading(false);

        }
    };

    useEffect(() => {

        loadSalarySlip();

    }, []);

    const printSlip = () => {

        window.print();

    };

    const earningsFooter = () => {

        if (!selectedSlip)
            return null;

        return (
            <div className="salary-total-row">
                <span>Gross Salary</span>

                <strong>
                    {money(selectedSlip.grossSalary)}
                </strong>
            </div>
        );
    };

    const deductionsFooter = () => {

        if (!selectedSlip)
            return null;

        return (
            <div className="salary-total-row">
                <span>Total Deduction</span>

                <strong>
                    {money(selectedSlip.totalDeduction)}
                </strong>
            </div>
        );
    };

    return (

        <div className="salary-slip-page">

            {/* =====================================================
                SEARCH
            ====================================================== */}

            <Card
                title="Monthly Salary Slip"
                className="salary-search-card no-print"
            >

                <div className="p-fluid formgrid grid">

                    <div className="field col-12 md:col-3">

                        <label>
                            Salary Month
                        </label>

                        <Dropdown
                            value={month}
                            options={months}
                            onChange={(e) =>
                                setMonth(e.value)
                            }

                            placeholder="Select Month"
                        />

                    </div>

                    <div className="field col-12 md:col-3">

                        <label>
                            Salary Year
                        </label>

                        <Dropdown
                            value={year}
                            options={years}
                            onChange={(e) =>
                                setYear(e.value)
                            }

                            placeholder="Select Year"
                        />

                    </div>

                    <div className="field col-12 md:col-3">

                        <label>
                            Employee Code
                        </label>

                        <input
                            type="text"
                            className="p-inputtext p-component"
                            value={empCode}
                            onChange={(e) =>
                                setEmpCode(e.target.value)
                            }

                            placeholder="Leave blank for all"
                        />

                    </div>

                    <div className="field col-12 md:col-3 salary-search-button">

                        <Button
                            label="Generate Salary Slip"
                            icon="pi pi-search"
                            onClick={loadSalarySlip}
                            loading={loading}
                        />

                    </div>

                </div>

            </Card>

            {/* =====================================================
                ERROR
            ====================================================== */}

            {error && (

                <Message
                    severity="error"
                    text={error}
                    className="w-full no-print"
                />

            )}

            {/* =====================================================
                EMPLOYEE SELECTOR
            ====================================================== */}

            {salarySlips.length > 1 && (

                <Card
                    className="no-print"
                    title="Employees"
                >

                    <DataTable
                        value={salarySlips}
                        selection={selectedSlip}
                        onSelectionChange={(e) =>
                            setSelectedSlip(e.value)
                        }

                        selectionMode="single"
                        dataKey="employee.empCode"
                        paginator
                        rows={10}
                    >

                        <Column
                            field="employee.empCode"
                            header="Employee Code"
                        />

                        <Column
                            field="employee.empName"
                            header="Employee Name"
                        />

                        <Column
                            field="employee.designation"
                            header="Designation"
                        />

                        <Column
                            field="netSalary"
                            header="Net Salary"
                            body={(row) =>
                                money(row.netSalary)
                            }
                        />

                    </DataTable>

                </Card>

            )}

            {/* =====================================================
                LOADING
            ====================================================== */}

            {loading && (

                <div className="salary-loading">

                    <ProgressSpinner />

                </div>

            )}

            {/* =====================================================
                SALARY SLIP
            ====================================================== */}

            {!loading &&
                selectedSlip &&
                (

                    <div className="salary-slip-container">

                        <div className="salary-slip">

                            {/* HEADER */}

                            <div className="salary-header">

                               <div className="company-details">

    <h1>
        {selectedSlip.company.company}
    </h1>

    <p>
        {selectedSlip.company.address}
    </p>

    <p>
        Phone: {selectedSlip.company.phone}
    </p>

    <p>
        Email: {selectedSlip.company.email}
    </p>

</div>


                                <div className="salary-title">

                                    <h2>
                                        SALARY SLIP
                                    </h2>

                                    <div>
                                        {
                                            selectedSlip
                                                .employee
                                                .salaryMonthName
                                        }{" "}
                                        {
                                            selectedSlip
                                                .employee
                                                .salaryYear
                                        }
                                    </div>

                                </div>

                            </div>

                            <hr />

                            {/* EMPLOYEE INFORMATION */}

                            <div className="employee-info">

                                <div>

                                    <div className="info-row">

                                        <span>
                                            Employee Code
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .empCode
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Employee Name
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .empName
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Designation
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .designation
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Joining Date
                                        </span>

                                        <strong>
                                            {formatDate(
                                                selectedSlip
                                                    .employee
                                                    .joiningDate
                                            )}
                                        </strong>

                                    </div>

                                </div>

                                <div>

                                    <div className="info-row">

                                        <span>
                                            Salary Month
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .salaryMonthName
                                            }{" "}
                                            {
                                                selectedSlip
                                                    .employee
                                                    .salaryYear
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Total Days
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .totalDays
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Leave Days
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .approvedLeaveDays
                                            }
                                        </strong>

                                    </div>

                                    <div className="info-row">

                                        <span>
                                            Payable Days
                                        </span>

                                        <strong>
                                            {
                                                selectedSlip
                                                    .employee
                                                    .payableDays
                                            }
                                        </strong>

                                    </div>

                                </div>

                            </div>

                            {/* =================================================
                                EARNINGS / DEDUCTIONS
                            ================================================== */}

                            <div className="salary-columns">

                                {/* EARNINGS */}

                                <div className="salary-section">

                                    <h3>
                                        Earnings
                                    </h3>

                                    <table className="salary-table">

                                        <thead>

                                            <tr>

                                                <th>
                                                    Description
                                                </th>

                                                <th className="amount">
                                                    Amount
                                                </th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            {selectedSlip
                                                .earnings
                                                .map((item) => (

                                                    <tr
                                                        key={
                                                            item.salaryID
                                                        }
                                                    >

                                                        <td>
                                                            {
                                                                item.payName
                                                            }
                                                        </td>

                                                        <td className="amount">
                                                            {
                                                                money(
                                                                    item.amount
                                                                )
                                                            }
                                                        </td>

                                                    </tr>

                                                ))}

                                            {selectedSlip
                                                .earnings
                                                .length === 0 && (

                                                <tr>

                                                    <td
                                                        colSpan="2"
                                                        className="empty"
                                                    >
                                                        No earnings
                                                    </td>

                                                </tr>

                                            )}

                                        </tbody>

                                        <tfoot>

                                            <tr>

                                                <th>
                                                    Gross Salary
                                                </th>

                                                <th className="amount">
                                                    {
                                                        money(
                                                            selectedSlip
                                                                .grossSalary
                                                        )
                                                    }
                                                </th>

                                            </tr>

                                        </tfoot>

                                    </table>

                                </div>


                                {/* DEDUCTIONS */}

                                <div className="salary-section">

                                    <h3>
                                        Deductions
                                    </h3>

                                    <table className="salary-table">

                                        <thead>

                                            <tr>

                                                <th>
                                                    Description
                                                </th>

                                                <th className="amount">
                                                    Amount
                                                </th>

                                            </tr>

                                        </thead>

                                        <tbody>

                                            {selectedSlip
                                                .deductions
                                                .map((item) => (

                                                    <tr
                                                        key={
                                                            item.salaryID
                                                        }
                                                    >

                                                        <td>
                                                            {
                                                                item.payName
                                                            }
                                                        </td>

                                                        <td className="amount">
                                                            {
                                                                money(
                                                                    item.amount
                                                                )
                                                            }
                                                        </td>

                                                    </tr>

                                                ))}

                                            {selectedSlip
                                                .deductions
                                                .length === 0 && (

                                                <tr>

                                                    <td
                                                        colSpan="2"
                                                        className="empty"
                                                    >
                                                        No deductions
                                                    </td>

                                                </tr>

                                            )}

                                        </tbody>

                                        <tfoot>

                                            <tr>

                                                <th>
                                                    Total Deduction
                                                </th>

                                                <th className="amount">
                                                    {
                                                        money(
                                                            selectedSlip
                                                                .totalDeduction
                                                        )
                                                    }
                                                </th>

                                            </tr>

                                        </tfoot>

                                    </table>

                                </div>

                            </div>

                            {/* NET SALARY */}

                            <div className="net-salary">

                                <span>
                                    NET SALARY
                                </span>

                                <strong>
                                    {
                                        money(
                                            selectedSlip.netSalary
                                        )
                                    }
                                </strong>

                            </div>

                            {/* LEAVE DETAILS */}

                            {selectedSlip.leaves &&
                                selectedSlip.leaves.length > 0 && (

                                    <div className="leave-section">

                                        <h3>
                                            Leave Details
                                        </h3>

                                        <table className="salary-table">

                                            <thead>

                                                <tr>

                                                    <th>
                                                        Leave Type
                                                    </th>

                                                    <th>
                                                        From
                                                    </th>

                                                    <th>
                                                        To
                                                    </th>

                                                    <th>
                                                        Days
                                                    </th>

                                                    <th>
                                                        Status
                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {selectedSlip
                                                    .leaves
                                                    .map((leave) => (

                                                        <tr
                                                            key={
                                                                leave.leaveDetailId
                                                            }
                                                        >

                                                            <td>
                                                                {
                                                                    leave.leaveTypeName
                                                                }
                                                            </td>

                                                            <td>
                                                                {formatDate(
                                                                    leave.dateFrom
                                                                )}
                                                            </td>

                                                            <td>
                                                                {formatDate(
                                                                    leave.dateTo
                                                                )}
                                                            </td>

                                                            <td>
                                                                {
                                                                    leave.approvedForDays
                                                                }
                                                            </td>

                                                            <td>
                                                                {
                                                                    leave.status
                                                                }
                                                            </td>

                                                        </tr>

                                                    ))}

                                            </tbody>

                                        </table>

                                    </div>

                                )}

                            {/* AMOUNT IN WORDS */}

                            <div className="amount-words">

                                <strong>
                                    Amount in Words:
                                </strong>

                                <span>
                                    {numberToWords(
                                        selectedSlip.netSalary
                                    )}
                                </span>

                            </div>

                            {/* FOOTER */}

                            <div className="salary-footer">

                                <div>
                                    Employee Signature
                                </div>

                                <div>
                                    Authorized Signature
                                </div>

                            </div>

                        </div>

                        {/* PRINT BUTTON */}

                        <div className="print-container no-print">

                            <Button
                                label="Print Salary Slip"
                                icon="pi pi-print"
                                onClick={printSlip}
                            />

                        </div>

                    </div>

                )}

        </div>
    );
}


/* =============================================================
   NUMBER TO WORDS
   ============================================================= */

function numberToWords(amount) {

    amount = Number(amount || 0);

    const rupees = Math.floor(amount);

    const paise =
        Math.round(
            (amount - rupees) * 100
        );

    const words = convertNumber(rupees);

    if (paise > 0) {

        return (
            words +
            " Rupees and " +
            convertNumber(paise) +
            " Paise Only"
        );

    }

    return words + " Rupees Only";
}


function convertNumber(number) {

    if (number === 0)
        return "Zero";

    const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen"
    ];

    const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety"
    ];

    function twoDigits(n) {

        if (n < 20)
            return ones[n];

        return (
            tens[Math.floor(n / 10)] +
            (n % 10 ? " " + ones[n % 10] : "")
        );
    }

    let result = "";

    if (number >= 10000000) {

        result +=
            convertNumber(
                Math.floor(number / 10000000)
            ) +
            " Crore ";

        number %= 10000000;
    }

    if (number >= 100000) {

        result +=
            convertNumber(
                Math.floor(number / 100000)
            ) +
            " Lakh ";

        number %= 100000;
    }

    if (number >= 1000) {

        result +=
            convertNumber(
                Math.floor(number / 1000)
            ) +
            " Thousand ";

        number %= 1000;
    }

    if (number >= 100) {

        result +=
            ones[Math.floor(number / 100)] +
            " Hundred ";

        number %= 100;
    }

    if (number > 0) {

        if (result !== "")
            result += "and ";

        result += twoDigits(number);
    }

    return result.trim();
}

export default SalarySlip;
